<template>
  <v-card class="folder-card " outlined @click="$emit('click')" >
    <div class="d-flex justify-space-between align-start">
      <div>
        <div class="font-weight-bold text-body-1">{{ folder.name }}</div>
        <div class="text-caption grey--text">
          {{ folder.sub_folder.length }} Subcarpetas
        </div>
        <div class="text-caption grey--text" v-if="folder.documents">{{ folder.documents.length }} Documentos</div>
      </div>

      <!-- Menú desplegable  -->
      <v-menu offset-y v-if="canEditDelete">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="grey--text text--darken-2" v-bind="attrs" v-on="on" @click.stop>
            mdi-dots-vertical
          </v-icon>
        </template>

        <v-list>
          <v-list-item @click.stop="$emit('editItem', folder)">
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="$emit('deleteItem', folder)">
            <v-list-item-title class="red--text">Eliminar</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div class="d-flex justify-end mt-15">
      <v-icon :color="folder.color" size="36">mdi-folder</v-icon>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CardFolder",
  props: {
    folder: Object,
    legajo_id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
  canEditDelete() {
      if (this.legajo_id === null || this.legajo_id === undefined) {
        return this.folder.legajo === null;
      }

      return this.folder.legajo === this.legajo_id;
    }
  },
  methods: {
    getBoxShadowStyle(color) {
      return {
        boxShadow: `0 1px 6px ${color}`,
      };
    },
  }

};
</script>
